import {EntityLinkedToAccountWithAuditMetadata} from '../../../../common/entity/entityLinkedToAccountWithAuditMetadata';
import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class ReportDefinitionSummaryModel extends EntityLinkedToAccountWithAuditMetadata implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    label: string;
    type: LovValueSummary;
    active: boolean;
    title: string;
    lineBreakBetweenItems: boolean;
    lineBreakAfterContent: boolean;
}

export enum ReportDefinitionPermissions {
    REPORT_DEFINTION_SET_ACTIVE = 'REPORT_DEFINTION_SET_ACTIVE'
}

